var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"secretClass"},[_c('h5',[_vm._v("Secret View Window (Component will live inside this)")]),_c('SecretDatabaseStats')],1)}
var staticRenderFns = []

export { render, staticRenderFns }